<template>
  <div
    :id="tableTitle.replaceAll(' ', '')"
    :class="tableTitle.replaceAll(' ', '') + 'kendo_table_wrapper'"
    class="col-12 p-0 peelhunt_kendo_table_wrapper"
  >
    <fullscreen
      class="full-screen"
      ref="fullscreen"
      :fullscreen.sync="isFullScreen"
    >
      <!--Table-->
      <div class="col-12 mb-3" ref="capture">
        <b-row>
          <b-col lg="12" class="">
            <div class="w-100 vertical-align">
              <b-col class="col col-12 col-lg-12 p-0">
                <div class="row dropSearchAlign">
                  <b-form-group class="col-6 p-0">
                    <div class="col-12 p-0">
                      <h3 class="m-0 heading-text">
                        {{ tableTitle }}
                        <div
                          v-if="!switchButton"
                          class="infoDiv infoDivIcon"
                          :id="compId"
                        >
                          <i class="fas fa-info-circle"></i>
                        </div>
                        <b-tooltip
                          v-if="!switchButton"
                          :target="compId"
                          triggers="hover"
                        >
                          <p class="m-0 p-0">
                            Jensen's alpha (%): 3 year average benchmark return
                            is considered to calculate excess returns
                          </p>
                          <p class="m-0 p-0">
                            Standard deviation (%): Value represents yearly
                            Standard deviation using 3 years of daily data.
                          </p>
                          <p class="m-0 p-0">
                            Beta: Historical 3 years daily data used to
                            calculate Beta
                          </p>
                          <p class="m-0 p-0">
                            R-squared: Historical 3 years daily data used to
                            calculate R-squared
                          </p>
                          <p class="m-0 p-0">
                            Treynor ratio: 3 year average return is used to
                            calculate ratio
                          </p>
                          <p class="m-0 p-0">
                            Sharpe ratio: 3 year average return is used to
                            calculate ratio
                          </p>
                          <p class="m-0 p-0">
                            Information ratio: 3 year average return is used to
                            calculate ratio
                          </p>
                          <p class="m-0 p-0">
                            Sortino ratio: Average of yearly returns of last 5
                            years.
                          </p></b-tooltip
                        >
                      </h3>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-6 p-0" style="">
                    <div class="col-12">
                      <b-row class="dropSearchAlign">
                        <b-input-group>
                          <b-row class="toggle-container" v-if="switchButton">
                            <p
                              class="font-weight-bold"
                              :class="{ 'absolute-blue': !checked }"
                            >
                              Absolute return
                            </p>
                            <div class="" style="width: 45px; margin: 0 5px">
                              <k-switch
                                style="width: 45px"
                                @change="onChange"
                                :disabled="!tableData.length"
                                :checked="checked"
                              />
                            </div>
                            <p
                              class="font-weight-bold"
                              :class="{ 'relative-blue': checked }"
                            >
                              Relative return
                            </p>
                          </b-row>
                        </b-input-group>
                        <b-input-group>
                          <b-button
                            class="btn downloadBtn"
                            title="Export to Excel"
                            :theme-color="'primary'"
                            :disabled="!tableData.length"
                            @click="exportExcel"
                          >
                            <img :src="DownloadIcon" alt="'DownloadIcon" />
                          </b-button>
                        </b-input-group>
                        <b-input-group class="d-none">
                          <button
                            type="button"
                            title="Full Screen"
                            class="btn downloadBtn mr-0"
                            @click="toggle"
                          >
                            <img :src="FullScreen" alt="'FullScreen" />
                          </button>
                        </b-input-group>
                      </b-row>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <div class="col-12">
            <div class="row">
              <PulseLoader
                v-if="PulseLoaderToggle.table"
                :style="{ maxHeight: '500px' }"
                :title="LoaderTitle"
              ></PulseLoader>
            </div>
            <b-row>
              <!-- on click table filter icon show custom filter popup.  -->
              <PricePerformanceTable
                :style="{ maxHeight: '500px' }"
                :tableData="tableData"
                :tableColumns="columns"
                switchButton="true"
                :tableTitle="tableTitle"
              >
              </PricePerformanceTable>
            </b-row>
          </div>
          <p
            v-if="switchButton && checked"
            class="font_size_12 font-weight-bold pt-2"
          >
            *Returns as compared to selected benchmark index
          </p>
        </b-row>
      </div>
    </fullscreen>
  </div>
</template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import { Grid } from "@progress/kendo-vue-grid";
import { Switch } from "@progress/kendo-vue-inputs";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
import DownloadIcon from "../../../assets/img/icons/svg/download.svg";
import FullScreen from "../../../assets/img/icons/svg/full_screen.svg";
import PricePerformanceTable from "./PricePerformanceTable.vue";
import PulseLoader from "./PulseLoader.vue";

export default {
  name: "PricePerformance",
  components: {
    // Grid: Grid,
    "k-switch": Switch,
    PricePerformanceTable: PricePerformanceTable,
    PulseLoader,
  },
  props: {
    tableTitle: {
      default() {
        return "";
      },
    },
    tableData: {
      default() {
        return [];
      },
    },
    tableColumns: {
      type: Array,
      default() {
        return [];
      },
    },
    switchButton: {
      default() {
        return false;
      },
    },
    pulseLoader: {
      type: Object,
      default() {
        return {};
      },
    },
    compId: {
      type: String,
      default() {
        return "";
      },
    },
  },
  watch: {
    tableData: {
      deep: true,
      handler() {
        this.dataItems = [];
        this.$nextTick(() => {
          if (this.tableData && this.tableData.length) {
            this.dataItems = this.tableData;
            // console.log("this.dataItems", this.tableTitle, this.dataItems);
          } else {
            this.dataItems = [];
          }
        });
      },
    },
    tableColumns: {
      deep: true,
      handler() {
        if (this.tableColumns && this.tableColumns.length) {
          this.columns = this.tableColumns;
          // console.log("this.columns", this.tableTitle, this.columns);
        } else {
          this.columns = [];
        }
      },
    },
    tableTitle: {
      deep: true,
      handler() {},
    },
  },
  data: function() {
    return {
      loader: false,
      sort: [{ field: "ProductName", dir: "asc" }],
      columns: [],
      DownloadIcon,
      FullScreen,
      isFullScreen: false,
      checked: false,
      searchWord: "",
      skip: 0,
      take: 10,
      pageSize: 10,
      group: [],
      SelectedValue: {},
      dataState: {
        take: 0,
        skip: 0,
      },
      //   filter: null,
      grid: "",
      dataItems: [],
      allowUnsort: true, // unsorted or clear sorting.
      multiple: false, // multiple filter enable/disable
      ascDesc: true,
      LoaderTitle: "Please wait Loading...",
      PulseLoaderToggle: this.pulseLoader,
    };
  },
  computed: {
    result: {
      get: function() {
        return orderBy(this.createRandomData(500), this.sort);
      },
    },
    items: {
      get: function() {
        return this.dataItems.slice(this.skip, this.take + this.skip);
      },
    },
  },
  methods: {
    sortChangeHandler: function(e) {
      //   this.loader = true;
      // The idea behind using the following setTimeout method is to
      // demonstrate how we can show a loader while fetching data.
      // In a real-life scenarios with remote data binding, the 'loader'
      // property should be updated before making a server request
      // and after the request completes.
      setTimeout(() => {
        this.loader = false;
        this.sort = e.sort;
      }, 200);
    },
    createRandomData(count) {
      const productNames = [
        "Chai",
        "Chang",
        "Syrup",
        "Apple",
        "Orange",
        "Banana",
        "Lemon",
        "Pineapple",
        "Tea",
        "Milk",
      ];
      const unitPrices = [12.5, 10.1, 5.3, 7, 22.53, 16.22, 20, 50, 100, 120];
      const units = [2, 7, 12, 25, 67, 233, 123, 53, 67, 89];

      return Array(count)
        .fill({})
        .map((_, idx) => ({
          ProductID: idx + 1,
          ProductName:
            productNames[Math.floor(Math.random() * productNames.length)],
          UnitPrice: unitPrices[Math.floor(Math.random() * unitPrices.length)],
          UnitsInStock: units[Math.floor(Math.random() * units.length)],
        }));
    },
    // on change toggel button emit value
    onChange(e) {
      this.checked = e.target.value;
      this.$emit("pricePerformanceToggel", this.checked);
    },
    // export table data here in excel--------
    exportExcel() {
      const columnsToExport = [...this.tableColumns];
      columnsToExport.splice(0, 0);
      saveExcel({
        data: this.tableData,
        group: this.group,
        fileName: this.tableTitle,
        columns: columnsToExport,
      });
    },
    // full screen table
    toggle() {
      this.isFullScreen = !this.isFullScreen;
    },
    getNestedValue: function(fieldName, dataItem) {
      const path = fieldName.split(".");
      let data = dataItem;
      path.forEach((p) => {
        data = data ? data[p] : undefined;
      });

      return data;
    },
  },
};
</script>
